import React from 'react';
import PropTypes from 'prop-types';

import { HIDE_NAV_MENU } from '../../constants';

import NavComponent from './NavComponent';
import HeaderComponent from './HeaderComponent';

import './HeaderNavComponent.scss';

class HeaderNavComponent extends React.Component {
    render() {
        const { hideNav, hideSearch } = this.props;
        return (
            <div
                id="entete"
                className={`entete ${hideNav ? 'hideNav' : ''} ${
                    HIDE_NAV_MENU ? 'minimal' : ''
                }`}>
                <div className="flex-container-v">
                    <HeaderComponent hideSearch={hideSearch} hideNav={hideNav} />
                    {!hideNav && <NavComponent />}
                </div>
            </div>
        );
    }
}

HeaderNavComponent.propTypes = {
    hideNav: PropTypes.bool,
    hideSearch: PropTypes.bool
};

export default HeaderNavComponent;



// WEBPACK FOOTER //
// ./src/components/header/HeaderNavComponent.js